import React, {FunctionComponent, useContext} from 'react';
import {observer} from "mobx-react";
import UITranslations from "../../../../store/uiTranslations";
import {Context} from "../../../../store/context";
import {UrlBuilder} from "../../../../utils/urlBuilder";
import {Typography} from "@material-ui/core";
import TranslatedText from "../../../ui/TranslatedText/TranslatedText";
import TranslatedNode from "../../../ui/TranslatedNode/TranslatedNode";
import Link from "@material-ui/core/Link";
import {Routes} from "../../../../routes";
import {ChannelParam} from "../../../../store/QueryParamsStore/QueryParamsEnums";
import TranslatedNodeDestination from '../../../ui/TranslatedNode/TranslatedNodeDestination';

interface IAfterwardsProceedItem {}

const AfterwardsProceedItem:FunctionComponent<IAfterwardsProceedItem> = ()=>{
    const ui = UITranslations.GettingToPage.Wizard.Entrance;

    const {gettingToPageStore, languagesStore} = useContext(Context);
    const {settings} = gettingToPageStore;

    if(!settings)
        return null;

    const photoRouteLink = UrlBuilder.Relative(Routes.PhotoRoute)
        .searchParams({
            buildingId: settings.buildingId,
            nodeFrom: settings.firstReportId,
            nodeTo: settings.destinationId,
            routeLang: languagesStore.currentIETF,
            channel: ChannelParam.AppIntScreen
        }).href;

    return <Typography>
        <TranslatedText source={ui.Afterwards}/>
        {' '}
        <Link href={photoRouteLink} underline="always">
            <TranslatedText source={ui.To}/>
            {' '}
            <strong><TranslatedNodeDestination id={settings.destinationId as any}/></strong>
        </Link>
    </Typography>
};

export default observer(AfterwardsProceedItem);
